import type { ColumnDef } from '@vnetwork/ui/data';
import type { Bucket } from '@/api/s3';
import { RowMenu } from '../../components/RowMenu';
import { LinkButton, Mono } from '../s3-parts';

export interface BucketRowActions {
  onOpen: (bucket: Bucket) => void;
  onSettings: (bucket: Bucket) => void;
  onRename: (bucket: Bucket) => void;
  onEmpty: (bucket: Bucket) => void;
  onDelete: (bucket: Bucket) => void;
}

function formatDate(raw?: string | null): string {
  if (!raw) return '—';
  const d = new Date(raw);
  return Number.isNaN(d.getTime()) ? raw : d.toLocaleString();
}

/** Column set for the bucket list table — name links to the object browser. */
export function bucketColumns(actions: BucketRowActions): ColumnDef<Bucket, unknown>[] {
  return [
    {
      id: 'name',
      header: 'Name',
      cell: ({ row }) => (
        <LinkButton onClick={() => actions.onOpen(row.original)}>
          {row.original.name}
        </LinkButton>
      ),
    },
    {
      id: 'creation_date',
      header: 'Created',
      size: 220,
      cell: ({ row }) => <Mono>{formatDate(row.original.creation_date)}</Mono>,
    },
    {
      id: 'actions',
      header: '',
      size: 64,
      cell: ({ row }) => (
        <RowMenu
          items={[
            { label: 'Browse objects', onSelect: () => actions.onOpen(row.original) },
            { label: 'Settings', onSelect: () => actions.onSettings(row.original) },
            { label: 'Rename', onSelect: () => actions.onRename(row.original) },
            { label: 'Empty bucket', onSelect: () => actions.onEmpty(row.original) },
            { label: 'Delete', onSelect: () => actions.onDelete(row.original), danger: true },
          ]}
        />
      ),
    },
  ];
}
